class LatchesController

  @updateSelectOptions: (url, element_id) ->
    $.ajax({
      url: url,
      data: element_id+'=' + $('#'+element_id).val(),
      dataType: 'script'
    })

  @toggleAmountInput: ->
    checkbox = $('#node_state_change_request_charge_normal_amount')[0]
    amount_field = $('#node_state_change_request_amount')[0]

    return unless checkbox

    if checkbox.checked
      amount_field.disabled = true
    else
      amount_field.disabled = false

$(document).ready ->
  $(document).on('change', '#node_state_change_request_charge_normal_amount', (event) ->
    LatchesController.toggleAmountInput()
  )
  $(document).on('change', '#work_order_work_is_for_id', (event) ->
    LatchesController.updateSelectOptions($(this).data('url'), 'work_order_work_is_for_id')
  )
  LatchesController.toggleAmountInput()

module.exports = LatchesController
